export default "__VITE_ASSET__wUA_Bsf3__"